
import Button from '../../../components/base/Button';

export default function HeroSection() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      id="home"
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/77ba48b32550df904e2e863c1e75ac5b.jpg')`
      }}
    >
      <div className="container mx-auto px-6 text-center text-white relative z-10">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
            Transforming Complex
            <span className="text-blue-400 block">Business Challenges</span>
            Into Intuitive Experiences
          </h1>
          <p className="text-xl md:text-2xl mb-8 text-gray-200 max-w-3xl mx-auto">
            JB Technologies specializes in enterprise-grade UX design solutions across 12+ industries, 
            delivering user-centered designs that drive digital transformation and business success.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button 
              size="lg" 
              className="bg-blue-600 hover:bg-blue-700"
              onClick={() => scrollToSection('case-studies')}
            >
              <i className="ri-eye-line mr-2"></i>
              View Case Studies
            </Button>
            <Button 
              variant="outline" 
              size="lg"
              className="border-white text-white hover:bg-white hover:text-gray-900"
              onClick={() => scrollToSection('contact')}
            >
              <i className="ri-message-3-line mr-2"></i>
              Start a Project
            </Button>
          </div>
          
          <div className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-3xl font-bold text-blue-400">12+</div>
              <div className="text-sm text-gray-300">Industries Served</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-blue-400">150+</div>
              <div className="text-sm text-gray-300">Projects Completed</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-blue-400">98%</div>
              <div className="text-sm text-gray-300">Client Satisfaction</div>
            </div>
            <div>
              <div className="text-3xl font-bold text-blue-400">8+</div>
              <div className="text-sm text-gray-300">Years Experience</div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <button 
          onClick={() => scrollToSection('about')}
          className="w-12 h-12 rounded-full border-2 border-white/50 flex items-center justify-center hover:border-white transition-colors cursor-pointer"
        >
          <i className="ri-arrow-down-line text-white text-xl"></i>
        </button>
      </div>
    </section>
  );
}
